import React, { useMemo, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PDFViewer = ({ url, scale }) => {
    const [numPages, setNumPages] = useState(1);
    const isMobile = window.innerWidth <= 992

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    const options = useMemo(() => ({ workerSrc: "/pdf.worker.js" }), []);

    return (
        <div className="pdf-viewer">
            <Document
                file={url}
                onLoadSuccess={onDocumentLoadSuccess}
                options={options}
            >
                {Array.from(new Array(numPages), (el, index) => (
                    <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        width={(window.innerWidth * 0.8) - (isMobile ? 80 : 150)}
                        renderTextLayer={false}
                        scale={scale} // Apply zoom level
                        renderAnnotationLayer={false}
                    />
                ))}
            </Document>
        </div>
    );
};

export default PDFViewer;